module.exports = __webpack_public_path__ + "static/media/img_select03.41f321e2.jpg";